import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { DocumentCreationModalContainer } from '@/features/documents/DocumentCreationModal/DocumentCreationModalContainer'
import { MessageBankDialogContainer } from '@/features/messaging/message-bank/MessageBankDialog/MessageBankDialogContainer'
import { CreateAmendmentDialogContainer } from '@/features/jobs/details/components/AmendmentsCard/CreateAmendmentDialog/CreateAmendmentDialogContainer'
import { CorrectionsDialogContainer } from '@/features/jobs/details/components/CorrectionsDialog/CorrectionsDialogContainer'
import { RenameJobDialogContainer } from '@/features/jobs/RenameJobDialog/RenameJobDialogContainer'
import { AddJobNoteDialogContainer } from '@/features/jobs/details/components/JobNotesCard/AddJobNoteDialog/AddJobNoteDialogContainer'
import { ForfeitDialogContainer } from '@/features/jobs/details/components/ForfeitDialog/ForfeitDialogContainer'
import { CloseJobAsAdminDialogContainer } from '@/features/jobs/details/components/CloseJobAsAdminDialog/CloseJobAsAdminDialogContainer'
import { RequestScopeChangesDialogContainer } from '@/features/jobs/details/components/RequestScopeChangesDialog/RequestScopeChangesDialogContainer'
import { CopyJobDialogContainer } from '@/features/jobs/CopyJobDialog/CopyJobDialogContainer'
import { TransferJobDialogContainer } from '@/features/jobs/TransferJobDialog/TransferJobDialogContainer'
import { RemoveCollaboratorsAsAdminDialogContainer } from '@/features/jobs/details/components/RemoveCollaboratorsAsAdminDialog/RemoveCollaboratorsAsAdminDialogContainer'
import { AddCollaboratorsAsAdminDialogContainer } from '@/features/jobs/details/components/AddCollaboratorsAsAdminDialog/AddCollaboratorsAsAdminDialogContainer'
import { ApplyCouponAsAdminDialogContainer } from '@/features/jobs/ApplyCouponAsAdminDialog/ApplyCouponAsAdminDialogContainer'
import { RemoveCouponAsAdminDialogContainer } from '@/features/jobs/RemoveCouponAsAdminDialog/RemoveCouponAsAdminDialogContainer'
import { DragAndDropOverlayContainer } from '@/features/jobs/details/components/DragAndDropOverlay/DragAndDropOverlayContainer'
import { ReopenJobAsAdminDialogContainer } from '@/features/jobs/details/components/ReopenJobAsAdminDialog/ReopenJobAsAdminDialogContainer'
import { RemoveClientTeamDialogContainer } from '@/features/jobs/details/components/RemoveClientTeamDialog/RemoveClientTeamDialogContainer'
import { ViewJobScopeChangeRequestDialogContainer } from '@/features/jobs/details/components/ViewJobScopeChangeRequestDialog/ViewJobScopeChangeRequestDialogContainer'
import { SplitPayoutDialogContainer } from '@/features/jobs/details/components/SplitPayoutDialog/SplitPayoutDialogContainer'
import { ApproveDraftInReviewDialogContainer } from '@/features/jobs/details/components/ApproveDraftInReviewDialog/ApproveDraftInReviewDialogContainer'
import { RejectDraftInReviewDialogContainer } from '@/features/jobs/details/components/RejectDraftInReviewDialog/RejectDraftInReviewDialogContainer'
import { DeleteJobDialogContainer } from '@/features/jobs/details/components/DeleteJobDialog/DeleteJobDialogContainer'
import { StartProgressionDialogContainer } from '@/features/jobs/details/components/JobProgressionCard/NoProgressionActions/StartProgressionDialog/StartProgressionDialogContainer'
import { JobProgressionHistoryModalContainer } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionHistoryModal/JobProgressionHistoryModalContainer'
import { JobProgressionDocumentCreationModalContainer } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionDocumentCreationModal/JobProgressionDocumentCreationModalContainer'
import { JobProgressionRequestDraftApprovalModalContainer } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionRequestDraftApprovalModal/JobProgressionRequestDraftApprovalModalContainer'
import { JobProgressionExtensionDocumentCreationModalContainer } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionExtensionDocumentCreationModal/JobProgressionExtensionDocumentCreationModalContainer'
import { EstimatedIrsPaymentDialogContainer } from '@/features/jobs/details/components/JobProgressionCard/EstimatedIrsPaymentDialog/EstimatedIrsPaymentDialogContainer'
import { FinalReturnAmountsDialogContainer } from '@/features/jobs/details/components/FinalReturnAmountsDialog/FinalReturnAmountsDialogContainer'
import { AddManualInvoiceDialogContainer } from '@/features/jobs/details/components/AddManualInvoiceDialog/AddManualInvoiceDialogContainer'
import { UpdateDeadlineDialogContainer } from '@/features/jobs/details/components/UpdateDeadlineDialog/UpdateDeadlineDialogContainer'
import { SubmitJobDialogContainer } from '@/features/jobs/details/components/SubmitJobDialog/SubmitJobDialogContainer'
import { NotifyProsOfOpenJobDialogContainer } from '@/features/jobs/details/components/NotifyProsOfOpenJobDialog/NotifyProsOfOpenJobDialogContainer'
import { ChargeOrRefundDialogContainer } from '@/features/jobs/details/components/ChargeOrRefundDialog/ChargeOrRefundDialogContainer'
import { RateProDialogContainer } from '@/features/jobs/details/ratings/components/RateProDialog/RateProDialogContainer'
import { UpdateJobScopeDialogContainer } from '@/features/jobs/details/components/UpdateJobScopeDialog/UpdateJobScopeDialogContainer'
import { ServiceItemListDialogContainer } from '@/features/jobs/details/components/ServiceItemListDialog/ServiceItemListDialogContainer'
import { AddClientsAsTeamMemberDialogContainer } from '@/features/jobs/details/components/AddClientsAsTeamMemberDialog/AddClientsAsTeamMemberDialogContainer'
import { RemoveClientsAsNonAdminDialogContainer } from '@/features/jobs/details/components/RemoveClientsAsNonAdminDialog/RemoveClientsAsNonAdminDialogContainer'
import { OpenItemsDialogContainer } from '@/features/jobs/details/components/JobProgressionCard/OpenItemsProgressionActions/OpenItemsDialog/OpenItemsDialogContainer'
import { UpdateProgressionStepDialogContainer } from '@/features/jobs/details/components/UpdateProgressionStepDialog/UpdateProgressionStepDialogContainer'
import { BookkeepingCompleteCycleDialogContainer } from '@/features/jobs/details/components/BookkeepingCompleteCycleDialog/BookkeepingCompleteCycleDialogContainer'
import { BookkeepingCompleteJobDialogContainer } from '@/features/jobs/details/components/BookkeepingCompleteJobDialog/BookkeepingCompleteJobDialogContainer'
import { BookkeepingSelectCycleDialogContainer } from '@/features/jobs/details/components/BookkeepingSelectCycleDialog/BookkeepingSelectCycleDialogContainer'
import { BookkeepingCorrectCycleDialogContainer } from '@/features/jobs/details/components/BookkeepingCorrectCycleDialog/BookkeepingCorrectCycleDialogContainer'
import { BookkeepingCycleDetailsDialogContainer } from '@/features/jobs/details/components/BookkeepingCycleDetailsDialog/BookkeepingCycleDetailsDialogContainer'
import { BookkeepingGrantAccessDialogContainer } from '@/features/jobs/details/components/BookkeepingGrantAccessDialog/BookkeepingGrantAccessDialogContainer'
import { DocumentRequestDialogContainer } from '@/features/jobs/details/components/DocumentRequestDialog/DocumentRequestDialogContainer'
import { InfoGatheringDialogsContainer } from '@/features/jobs/details/components/InfoGatheringDialogsContainer'
import { IncompleteConsultationCompletionDialogContainer } from '@/features/jobs/details/components/IncompleteConsultationCompletionDialog/IncompleteConsultationCompletionDialogContainer'
import { CompleteInfoGatheringDialogContainer } from '@/features/jobs/details/components/InfoGatheringCard/CompleteInfoGatheringDialog/CompleteInfoGatheringDialogContainer'

export interface JobDetailsDialogsHostContainerProps {
  vm: JobDetailsViewModel
}

/**
 * Hosts the dialogs of the job details view.
 */
export const JobDetailsDialogsHostContainer = observer(
  function JobDetailsDialogsHostContainer({
    vm,
  }: JobDetailsDialogsHostContainerProps) {
    const infoGatheringVm = vm.capturedInformationVm.infoGatheringCardVm

    return (
      <>
        <CreateAmendmentDialogContainer vm={vm.actionsVm.createAmendmentVm} />
        <ApproveDraftInReviewDialogContainer
          vm={vm.jobProgressionVm.approveDraftInReviewDialogVm}
        />
        <RejectDraftInReviewDialogContainer
          vm={vm.jobProgressionVm.rejectDraftInReviewDialogVm}
        />
        <StartProgressionDialogContainer
          vm={vm.jobProgressionVm.startProgressionDialogVm}
        />
        <JobProgressionHistoryModalContainer
          vm={vm.jobProgressionVm.historyDialogVm}
        />
        <OpenItemsDialogContainer vm={vm.jobProgressionVm.openItemsDialogVm} />
        <RenameJobDialogContainer vm={vm.actionsVm.renameVm} />
        <AddJobNoteDialogContainer vm={vm.jobNotesVm.addNoteVm} />
        <CorrectionsDialogContainer vm={vm.actionsVm.correctionsVm} />
        <TransferJobDialogContainer vm={vm.collaboratorsVm.transferJobVm} />
        <RemoveClientTeamDialogContainer
          vm={vm.collaboratorsVm.removeClientTeamVm}
        />
        <ForfeitDialogContainer vm={vm.actionsVm.forfeitVm} />
        <MessageBankDialogContainer vm={vm.messageBankDialogVm} />
        <CloseJobAsAdminDialogContainer
          vm={vm.actionsVm.closeJobAsAdminDialogVm}
        />
        <AddCollaboratorsAsAdminDialogContainer
          vm={vm.collaboratorsVm.addCollaboratorsAsAdminVm}
        />
        <AddClientsAsTeamMemberDialogContainer
          vm={vm.collaboratorsVm.addClientsAsTeamMemberVm}
        />
        <RemoveCollaboratorsAsAdminDialogContainer
          vm={vm.collaboratorsVm.removeCollaboratorsAsAdminVm}
        />
        <RemoveClientsAsNonAdminDialogContainer
          vm={vm.collaboratorsVm.removeClientsAsNonAdminVm}
        />
        <ReopenJobAsAdminDialogContainer vm={vm.actionsVm.reopenJobAsAdminVm} />
        <RateProDialogContainer
          vm={vm.collaboratorsVm.ratingsVm.rateProDialogVm}
        />
        <UpdateJobScopeDialogContainer
          vm={vm.scopeChangesVm.updateJobScopeVm}
        />
        <RequestScopeChangesDialogContainer
          vm={vm.scopeChangesVm.requestScopeChangesVm}
        />
        <ViewJobScopeChangeRequestDialogContainer
          vm={vm.scopeChangesVm.viewScopeChangeRequestVm}
        />
        <CopyJobDialogContainer vm={vm.actionsVm.copyVm} />
        <SplitPayoutDialogContainer vm={vm.billingVm.splitPayoutDialogVm} />
        <ApplyCouponAsAdminDialogContainer
          vm={vm.billingVm.applyCouponAsAdminVm}
        />
        <RemoveCouponAsAdminDialogContainer
          vm={vm.billingVm.removeCouponAsAdminVm}
        />
        {vm.documentsVm.documentCreationVm && (
          <DocumentCreationModalContainer
            vm={vm.documentsVm.documentCreationVm}
            overlay={
              <DragAndDropOverlayContainer
                vm={vm.documentsVm.documentCreationVm.uploadBarVm}
                targetJob={vm.documentsVm.documentCreationVm.job}
              />
            }
          />
        )}
        {vm.jobProgressionVm.jobProgressionDocumentCreationVm &&
          vm.jobProgressionVm.isDocumentCreationToggledViewReturnFiled && (
            <JobProgressionDocumentCreationModalContainer
              vm={vm.jobProgressionVm}
            />
          )}
        {vm.jobProgressionVm.jobProgressionDocumentCreationVm &&
          vm.jobProgressionVm.isDocumentCreationToggledViewExtension && (
            <JobProgressionExtensionDocumentCreationModalContainer
              vm={vm.jobProgressionVm}
            />
          )}
        {vm.jobProgressionVm.requestDraftReturnApprovalVm.documentViewModel && (
          <JobProgressionRequestDraftApprovalModalContainer
            vm={vm.jobProgressionVm.requestDraftReturnApprovalVm}
          />
        )}
        <EstimatedIrsPaymentDialogContainer
          vm={vm.jobProgressionVm.estimatedIrsPaymentDialogVm}
        />
        <FinalReturnAmountsDialogContainer
          vm={vm.jobProgressionVm.finalReturnAmountsDialogVm}
        />
        <DeleteJobDialogContainer vm={vm.actionsVm.deleteJobDialogVm} />
        <SubmitJobDialogContainer vm={vm.actionsVm.submitJobDialogVm} />
        <AddManualInvoiceDialogContainer
          vm={vm.billingVm.addManualInvoiceDialogVm}
        />
        <UpdateDeadlineDialogContainer
          vm={vm.actionsVm.updateDeadlineDialogVm}
        />
        <NotifyProsOfOpenJobDialogContainer
          vm={vm.actionsVm.notifyProsOfOpenJobDialogVm}
        />
        <ChargeOrRefundDialogContainer
          vm={vm.billingVm.chargeOrRefundDialogVm}
        />
        <ServiceItemListDialogContainer
          vm={vm.scopeChangesVm.serviceItemListVm}
        />
        <UpdateProgressionStepDialogContainer
          vm={vm.jobProgressionVm.updateProgressionStepDialogVm}
        />
        <BookkeepingCompleteCycleDialogContainer
          vm={
            vm.bookkeepingVm.bookkeepingProgressionVm.bookkeepingCompleteCycleVm
          }
        />
        <BookkeepingCompleteJobDialogContainer
          vm={
            vm.bookkeepingVm.bookkeepingProgressionVm.bookkeepingCompleteJobVm
          }
          jobVm={vm}
        />
        <BookkeepingSelectCycleDialogContainer
          vm={vm.bookkeepingVm.bookkeepingSelectCycleDialogVm}
        />
        <BookkeepingCorrectCycleDialogContainer
          vm={vm.bookkeepingVm.bookkeepingCorrectCycleDialogVm}
        />
        <BookkeepingCycleDetailsDialogContainer
          vm={
            vm.bookkeepingVm.bookkeepingProgressionVm.bookkeepingCycleDetailsVm
          }
        />
        <BookkeepingGrantAccessDialogContainer
          vm={vm.bookkeepingVm.bookkeepingGrantAccessDialogVm}
        />
        <DocumentRequestDialogContainer
          vm={vm.capturedInformationVm.documentRequestDialogVm}
        />
        <InfoGatheringDialogsContainer vm={vm.capturedInformationVm} />
        <IncompleteConsultationCompletionDialogContainer
          vm={vm.consultationVm.incompleteConsultationCompletionDialogVm}
        />
        <CompleteInfoGatheringDialogContainer
          vm={infoGatheringVm.completeInfoGatheringDialogVm}
          isAdmin={infoGatheringVm.isAdmin}
          requestedProName={infoGatheringVm.requestedPro?.displayName}
        />
      </>
    )
  },
)
